// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container---0cIG","singlePainting":"styles-module--singlePainting--2WZqX","modalButton":"styles-module--modalButton--1Wj5G"};